// extracted by mini-css-extract-plugin
export default {"box":"Main_box__pfC+2","heading":"Main_heading__LD-L5","subHeading":"Main_subHeading__V4v7b","buttonGroup":"Main_buttonGroup__yl72i","application":"Main_application__6O3BK"};